import 'core-js/stable'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import axios from 'axios' // import axios
import moment from  'moment'
import vueMomentJS from 'vue-momentjs'
//import router from './router'
import routers from './router/index.js'
import CoreuiVue from '@coreui/vue'
import VueSession from 'vue-session'
import { Datetime } from 'vue-datetime'
var sessionOptions = {
  persist: true
}

/*Vue.use(vueMomentJS, moment)*/
Vue.use(VueSession, sessionOptions)

import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
/*

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
*/


Vue.prototype.$axios = axios; // prototype에 axios 추가

Vue.config.productionTip = false
Vue.use(BootstrapVue)

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)



new Vue({
  el: '#app',
  router : routers,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
